// removed by extract-text-webpack-plugin
module.exports = {"add-button":"add-button___1oUP8","addButton":"add-button___1oUP8"};